import {
  InstrumentSubscriptionDataScope,
  InstrumentSubscriptionMap,
  SubscribeList,
  SubscribeOptions,
} from '../../types/estream/eStreamSubscription';
import { ListedInstrument } from '../../types/instrument/listedInstrument';

export const replaceSourceDataScope = (
  item: InstrumentSubscriptionMap,
  subscriptionSrc: string,
  changes: (existingDataScope: Array<InstrumentSubscriptionDataScope>) => Array<InstrumentSubscriptionDataScope>,
) => {
  return {
    ...item,
    source: {
      ...item.source,
      [subscriptionSrc]: changes(item.source[subscriptionSrc]),
    },
  };
};

export const getRicForChartData = (pRic: string): string => {
  if (pRic.endsWith('=')) {
    return `${pRic}X`;
  }

  return pRic;
};

export const getRicForInstrumentData = (pRic: string): string => {
  if (pRic.endsWith('USD=')) {
    return pRic.replace('USD=', '=');
  }
  return pRic;
};

export const getSubscribeOptions = (
  source: string,
  instrument: ListedInstrument | Array<ListedInstrument>,
  pDataScope?: Array<InstrumentSubscriptionDataScope>,
  forceRequestStaticData?: boolean,
): Array<SubscribeOptions> | SubscribeList => {
  const dataScope = pDataScope || [InstrumentSubscriptionDataScope.MarketData];
  if (Array.isArray(instrument)) {
    return {
      instruments: instrument,
      source,
      dataScope,
      forceRequestStaticData,
    };
  }
  return [
    {
      instrument,
      source,
      dataScope,
      forceRequestStaticData,
    },
  ];
};
